module.exports = __webpack_public_path__ + "static/img/duohe.cf310a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/duohe.png
// module id = sq0J
// module chunks = 1